import { useCore } from '../core'
import { isLocalhost } from '@booksy-com/vue-tools'

type WebToolsEnv = {
  VUE_APP_WEB_TOOLS_URL?: string
}

let envWebToolsUrl: string | null = null

export const initWebTools = (env: WebToolsEnv): null => {
  if (env.VUE_APP_WEB_TOOLS_URL) {
    envWebToolsUrl = env.VUE_APP_WEB_TOOLS_URL.replace(/\/+$/, '')
  }

  return null
}

const getWebToolsUrl = (): string => {
  const { store } = useCore()
  if (envWebToolsUrl) {
    return envWebToolsUrl
  }
  return store.getters['routingConfig/webToolsUrl']
}

const getRichTextInputJsUrl = (): string => {
  const webToolsUrl = getWebToolsUrl()
  if (isLocalhost(webToolsUrl)) {
    return webToolsUrl + '/src/views/rich-text-editor/index.ts'
  }
  return webToolsUrl + '/rich-text-editor/index.umd.js'
}

const getRichTextInputCssUrl = (): string => {
  const webToolsUrl = getWebToolsUrl()
  if (isLocalhost(webToolsUrl)) {
    return ''
  }
  return webToolsUrl + '/rich-text-editor/style.css'
}

const getRichTextInputIframeUrl = (): string => {
  const { store } = useCore()
  const webToolsUrl = getWebToolsUrl()
  return webToolsUrl + `/${(store.state as any).app.language}-${(store.state as any).app.country}/rich-text-editor`
}

const getEffortlessKycIframeUrl = (businessId = '', code = '', returnUrl = ''): string => {
  const { store } = useCore()
  const webToolsUrl = getWebToolsUrl()
  return webToolsUrl + `/${(store.state as any).app.language}-${(store.state as any).app.country}/${businessId}/consents/${code}?return_url=${returnUrl}`
}

type UseWebToolsResult = {
  getWebToolsUrl: () => string
  getRichTextInputJsUrl: () => string
  getRichTextInputCssUrl: () => string
  getRichTextInputIframeUrl: () => string
  getEffortlessKycIframeUrl: (businessId?: string, code?: string, returnUrl?: string) => string
}

export const useWebTools = (): UseWebToolsResult => {
  return {
    getWebToolsUrl,
    getRichTextInputJsUrl,
    getRichTextInputCssUrl,
    getRichTextInputIframeUrl,
    getEffortlessKycIframeUrl,
  }
}
